// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"c55643d0","136":"01f6449c","145":"dd6079b3","211":"e6f23230","881":"007d6ebc"}[chunkId] + ".chunk.js";
};